import { useSelector } from "react-redux";
import { Content } from "@webtypen/react-components";
import { DashboardAdmin } from "./DashboardAdmin";
import { DashboardEmployee } from "./DashboardEmployee";
import { DashboardCustomer } from "./DashboardCustomer";
import { Page } from "../components";

export const Dashboard = () => {
    const auth = useSelector((state) => state.app.auth);

    if (auth && auth.type === "admin") {
        return <DashboardAdmin />;
    }

    if (auth && auth.type === "employee") {
        return <DashboardEmployee />;
    }

    if (auth && auth.type === "customer_person") {
        return <DashboardCustomer />;
    }

    return (
        <Page title="Dashboard">
            <Content>Not available ...</Content>
        </Page>
    );
};
